import _ from 'lodash';

const experienceStates = {
  GALLERY:    'gallery',
  UNAPPROVED: 'unapproved', // TODO: still needed?
  INELIGIBLE: 'ineligible', // TODO: still needed?
  COUNTDOWN:  'countdown',
  CURTAIN:    'curtain',
};

experienceStates.ALL = _.values(experienceStates);

export default experienceStates;
